<template>
    <div ref="mywrap" class="wrap">
        <div id="light" class="light">
            <img src="https://img.js.design/assets/static/f6534a20f8c8b949944aca6a8cad7b15.png" class="width-full">
            <div ref="dark" class="dark">
                <img src="https://img.js.design/assets/static/b14c448118c24927478a047de659d429.png" class="width-full">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            event: null,
            darkDom: null,
        };
    },
    mounted() {
        this.event = function (e) {
            let allWidth = e.currentTarget.offsetWidth;
            let width = e.offsetX / allWidth;
            this.$refs.dark.style.width = `${(100 - width * 100).toFixed(2)}%`;
        }.bind(this);
        this.$refs.mywrap.addEventListener("mousemove", this.event, true);
    },
    unmounted() {
        window.removeEventListener("mousemove", this.event);
    },
}
</script>

<style scoped>
.light>img {
    width: 100%;
}

.light {
    position: relative;
}

.dark {
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    z-index: 10;
}

.dark img {
    position: absolute;
    right: 0;
    height: 100%;
    /* width: 100%; */
    object-fit: cover;
}
</style>